import React from 'react';
import { Input } from '../input';

export const CheckboxWrapper = ({ register, name, title, subtitle, disabled, checked, responsiveClassName, onChange, isDanger }) => {
  return (
    <div className={responsiveClassName}>
      <div className="space-y-4">
        <div className="flex items-center">
          <Input
            {...(register ? register(name) : {})}
            className={`
              ${isDanger ? 'focus:ring-red-500' : 'focus:ring-indigo-500'}
              ${isDanger && !disabled ? 'text-red-600' : 'text-indigo-600'}
              ${disabled ? 'text-gray-400' : ''}
              h-4 w-4 border-gray-300`}
            id={name}
            type="checkbox"
            disabled={disabled}
            onChange={onChange}
            checked={checked}
          />

          {!!title && (
          <div className="ml-3 text-sm">
            <label htmlFor={name} className={`${isDanger ? 'text-red-700' : 'text-gray-700'} font-medium`}>
              {title}
            </label>
            <p id={`${name}-description`} className="text-gray-500">
              <span className="sr-only">{title} </span> {subtitle}
            </p>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};
